import React from "react";
import { useSelector } from "react-redux";
import FollowUp from "../../service-steps/education/follow-up";
import Prevention from "../../service-steps/treatment/prevention";
import DrugEducation from "../../service-steps/education/drug-education";

const Education = () => {
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;

  const renderStep = () => {
    const subStep = currentSubStep === 0 ? 1 : currentSubStep;
    switch (subStep) {
      case 1:
        return <Prevention />;
      case 2:
        return <DrugEducation />;
      case 3:
        return <FollowUp />;
    }
  };
  return renderStep();
};

export default Education;
